import { render, staticRenderFns } from "./addChapter.vue?vue&type=template&id=ea5c4026"
import script from "./addChapter.vue?vue&type=script&lang=js"
export * from "./addChapter.vue?vue&type=script&lang=js"
import style0 from "./addChapter.vue?vue&type=style&index=0&id=ea5c4026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports